export default {
  data() {
    return {
      dropCells: [],
      draggingCell: null,
      isDraggable: false,
    }
  },
  methods: {
    isDropAllowed(cell) {
      return this.dropCells.indexOf(cell) > -1;
    },
    handleDrop(dropCell, dragCell) {
      if (!this.isDropAllowed(dropCell)) {
        this.dropCells = [];
        this.draggingCell = null;
        return false;
      }

      const dragCellClone = {...dragCell};
      const dropCellClone = {...dropCell};

      this.dropped(dropCellClone, dragCellClone);

      Object.keys(dropCell).forEach(
        k => delete dropCell[k]
      );
      Object.assign(dropCell, dragCellClone);
      Object.assign(dropCell, {row: dropCellClone.row});
      Object.assign(dropCell, {unit: dropCellClone.unit});
      Object.assign(dropCell, {row_id: dropCellClone.row_id});

      Object.keys(dragCell).forEach(
        k => delete dragCell[k]
      );
      Object.assign(dragCell, dropCellClone);
      Object.assign(dragCell, {row: dragCellClone.row});
      Object.assign(dragCell, {unit: dragCellClone.unit});
      Object.assign(dragCell, {row_id: dragCellClone.row_id});

      this.dropCells = [];
      this.draggingCell = null;
    },
    handleDragStart(cell, data, event) {
      this.dropCells = [];
      this.draggingCell = cell;

      cell.property.unit_categories.map((unit_category) => {
        unit_category.units.map((unit) => {
          if (cell.unit.id === unit.id) {
            return false;
          }
          unit.cells.map((dropCell) => {
            let isBusy = false;

            unit.cells.map((dropCell) => {
              if (
                dropCell.isReservation &&
                cell.column + cell.days > dropCell.column &&
                cell.column < dropCell.column + dropCell.days
              ) {
                isBusy = true;
              }
            });

            if (dropCell.column === cell.column && !isBusy) {
              this.dropCells.push(dropCell);
            }
          });
        });
      });
    },
    handleDragEnd(cell, data, event) {
      this.dropCells = [];
      this.draggingCell = null;
    },
    handleDrag(cell, data, event) {

    },
    handleDragOver(cell, data, event) {

    },
    handleDragEnter(cell, data, event) {

    },
    handleDragLeave(cell, data, event) {

    },
  },
  watch: {
    'properties.length'(length) {
      if (this.isDragDisabled) {
        this.isDraggable = false;
      }
    },
  },
  computed: {
    isDragDisabled() {
      return this.properties.length > 5;
    }
  }
}
